import React, { useEffect, useState } from "react"; import { useHistory } from "react-router-dom";
import * as OFMSUI from "react-bootstrap";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import { AiOutlineSearch } from "react-icons/ai"; import { MdOutlinePictureAsPdf } from "react-icons/md";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import HousingService from "../../../Services/HousingService";
import * as Yup from "yup"; import jsPDF from "jspdf"; import { FaSearch } from "react-icons/fa"; import moment from "moment";
import { Link } from "@mui/material";
import { store } from "../../../App";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { Table } from "react-bootstrap";
import { generatePDF, ModuleHeader } from "../../utils/commonFunctions";
import styled from "styled-components";
const TableWrapper = styled.div`width:130%`

const OTSReconsolationReport = () => {
    const history = useHistory();
    const [data, setData] = useState([]); const [tableEn, setTableEn] = useState(false);
    const [search, setSearch] = useState(""); const [distList, setDistList] = useState([]);
    const [error, setError] = useState(null); const [schemeList, setSchemeList] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const handleFocus = () => setIsFocused(true);
    const [data12, setdata1] = useState([]);
    const [enable, setenable] = useState(false);
    const [enable1, setenable1] = useState(false);
    const handleBlur = () => setIsFocused(false);
    const [tableDistEn, settableDistEn] = useState(false);
    const [tableDivEn, setTableDivEn] = useState(false);
    const [tableConstEn, setTableConstEn] = useState(false);
    const [tableMandalEn, settableMandalEn] = useState(false);
    const [districtData, setDistrictData] = useState([]);



    const formik = useFormik({

        initialValues: {
            report_type: "", district: "", FromDate: "", ToDate: "", scheme: "", Caste: "0",
        },
        validationSchema: Yup.object().shape({
            report_type: Yup.string().required("Report type is required"),
            district: Yup.string().when("report_type", {
                is: "scheme", then: Yup.string().required("District is required")
                    .notOneOf(["0", ""], "District is required"), otherwise: Yup.string().notRequired(),
            }),
            FromDate: Yup.string().required("FromDate is required"), ToDate: Yup.string().required("ToDate is required"),
        }), onSubmit: (values) => {
            console.log("distCode: values.district", values.district)
            let params = {
                reportType: values.report_type,
                distCode: values.district,
                fromDate: moment(values.FromDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
                toDate: moment(values.ToDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
                divCode: values.Caste, contCode: values.Caste, mandalCode: values.Caste,
                scheme: values.scheme

            }
            store.dispatch({ type: "SHOW_SPINNER" }); HousingService.OTSreconsolationreport(params).then((res) => {
                setData(res.data); setTableEn(true); settableDistEn(true)
                setTableDivEn(false); setTableConstEn(false); setenable(false);
                if (formik.values.report_type == "scheme") {
                    settableDistEn(false)
                }

            }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }) })
        }
    })
    const getOtsBenDetails = (detail) => {
        let params = {
            distCode: formik.values.report_type == "District" ? detail.dist_code : formik.values.district,
            // distCode: !detail.dist_code?0:detail.dist_code,
            fromDate: moment(formik.values.FromDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
            toDate: moment(formik.values.ToDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
            divCode: !detail.div_code ? 0 : detail.div_code,
            contCode: !detail.cont_code ? 0 : detail.cont_code,
            mandalCode: !detail.mandal_code ? 0 : detail.mandal_code,
            scheme: !detail.hsg_scheme_id ? 0 : detail.hsg_scheme_id

        }
        store.dispatch({ type: "SHOW_SPINNER" });
        HousingService.financeotsexponclick(params).then((res) => {
            if (res.data) {
                setdata1(res.data); setenable(true); setTableEn(false)
            }
            store.dispatch({ type: "HIDE_SPINNER" });
        });
    };

    useEffect(() => {
        formik.resetForm(); setTableEn(false); fetch('/districts.txt')
            .then(response => response.text())
            .then(text => {
                const data = JSON.parse(text);
                setDistrictData(data[0].Districts || []);
                let options = data[0].Districts?.map((item, i) => (
                    <option key={i} value={item.dist_code}>{item.dist_name}</option>
                ));
                setDistList(options);
            });
        //       fetch('/schems_dropdown.txt') .then(response => {
        // if (!response.ok) { throw new Error('Network Issues'); } return response.json(); }) .then(jsonData => {
        //   setSchemeList(jsonData || []);


        HousingService.getSchemeMaster().then((res) => {
            if (res.data) {
                let options = res.data.map((item, i) => {
                    return (<option key={i} value={item.scheme}>{item.scheme_name}</option>);
                });
                setSchemeList(options);
            }
        });


    }, [])



    const filteredData = search.length > 0 ? data?.filter((item) => {
        return (
            item && Object.keys(item).some((key) => {
                const value = item[key]; return (
                    value !== null && value.toString().toLowerCase().includes(search.toLowerCase()));
            }));
    }) : data;


    const handleGoBack = () => { history.goBack(); }

    function generate(table) {
        const pageWidth = 250; const pageHeight = 297; const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [pageWidth, pageHeight], });
        const headingText = "OTS Reconsolation Report"; const fontSize = 10;
        const textWidth = (doc.getStringUnitWidth(headingText) * fontSize) / doc.internal.scaleFactor;
        const xCoordinate = (pageWidth - textWidth) / 2; doc.setFontSize(fontSize); doc.text(headingText, xCoordinate, 10);
        doc.autoTable({
            html: `#${table}`, theme: "grid", tableWidth: "auto",
            columnStyles: { 8: { cellWidth: "wrap" }, }, startY: 20, margin: {
                top: 5,
                right: 5, bottom: 5, left: 5
            }, styles: { fontSize: 8, },
        }); doc.save("OTSReconsolationReport.pdf");
    }



    const DrilldownColumns = (report_type, dist_code, div_code, cont_code, mandal_code) => {
        let params = {
            reportType: report_type, distCode: dist_code,
            fromDate: moment(formik.values.FromDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
            toDate: moment(formik.values.ToDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
            divCode: (div_code === "" || div_code === null || div_code === "null" || div_code === undefined) ? 0 : div_code,
            contCode: (cont_code === "" || cont_code === null || cont_code === "null" || cont_code === undefined) ? 0 : cont_code,
            mandalCode: (mandal_code === "" || mandal_code === null || mandal_code === "null" || mandal_code === undefined) ? 0 : mandal_code,
            scheme: "0",
        }; store.dispatch({ type: "SHOW_SPINNER" }); HousingService.OTSreconsolationreport(params).then((res) => {
            setData(res.data); setTableEn(true);
        }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }) })

    }

    const districtName = districtData.find(d => d.dist_code === formik.values.district)?.dist_name || "All";






    return (
        <>
            <NavigationServicesHeader />
            <ModuleHeader title="OTS Re-consolation Report" />

            <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
                <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}> <ol className="breadcrumb"> <li className="breadcrumb-item">
                    <a href="Dashboardheader">Dashboard</a> </li> <li className="breadcrumb-item active" aria-current="page"> Report </li> </ol> </OFMSUI.Col>
                </OFMSUI.Row>

                <FormikProvider value={formik}> <Form onSubmit={formik.handleSubmit}>
                    <OFMSUI.Row className="border p-3 m-1 mb-3 align-items-center">
                        <OFMSUI.Col xs={12} sm={6} md={4} lg={2} xl={2} xxl={2} className="mb-3">
                            <label> <b> Report Type<span className="mandatory" style={{ color: "red" }}>   {" "} * </span> </b> </label>
                            <Field component="select" name="report_type"
                                className={formik.touched.report_type && formik.errors.report_type ? "form-control is-invalid" : "form-control"} onChange={(e) => {
                                    formik.handleChange(e); formik.setValues({
                                        ...formik.values, report_type: e.target.value, district: "0", Caste: "0",
                                        FromDate: "", ToDate: "", scheme: "0",
                                    }); setTableEn(false);
                                }} >
                                <option value="">Select</option> <option value="District">District Wise</option>
                                <option value="scheme">Scheme Wise</option>
                            </Field>
                        </OFMSUI.Col>

                        {(formik.values.report_type === "District" || formik.values.report_type === "scheme") && (
                            <OFMSUI.Col xs={12} sm={6} md={4} lg={2} xl={2} xxl={2} className="mb-3">
                                <label><b>District</b></label>
                                <Field component="select" name="district"
                                    className={formik.touched.district && formik.errors.district ? "form-control is-invalid" : "form-control"}
                                    onChange={(e) => { formik.handleChange(e); setTableEn(false); }} >
                                    {formik.values.report_type === "District" ? (<> <option value="0">All</option> {distList} </>
                                    ) : formik.values.report_type === "scheme" ? (<> <option value="">Select</option> {distList} </>) : null}
                                </Field> <ErrorMessage name="district" className="text-error" component="div" /> </OFMSUI.Col>
                        )}

                        {formik.values.report_type === "scheme" && (
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3">
                                {/* <FormGroup as={Col}> */}
                                <label> <b> Scheme</b> </label>
                                <span className="mandatory" style={{ color: "red" }}> * </span>
                                <Field component="select" name="scheme" className={formik.touched.scheme && formik.errors.scheme ? "form-control is-invalid" : "form-control"} onChange={(e) => { formik.handleChange(e); setTableEn(false); }} >
                                    <option value="0">All</option>
                                    {schemeList}
                                </Field>
                                {/* </FormGroup> */}
                            </OFMSUI.Col>)}


                        <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3">
                            <label> <b>From Date</b> </label>
                            <span className="mandatory" style={{ color: "red" }}> * </span>
                            <Field type="date" name="FromDate" className={
                                formik.touched.FromDate && formik.errors.FromDate ? "form-control is-invalid" : "form-control"} max={new Date().toISOString().split("T")[0]}
                                onChange={(e) => { formik.handleChange(e); setTableEn(false); }} >
                            </Field>
                        </OFMSUI.Col>

                        <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3">
                            <label> <b>To Date</b> </label>
                            <span className="mandatory" style={{ color: "red" }}> * </span>
                            <Field type="date" name="ToDate" className={
                                formik.touched.ToDate && formik.errors.ToDate ? "form-control is-invalid" : "form-control"} max={new Date().toISOString().split("T")[0]}
                                onChange={(e) => { formik.handleChange(e); setTableEn(false); }} >
                            </Field>
                        </OFMSUI.Col>
                        <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}> <center>  <button className="btn btn-primary btn-sm" type="submit" style={{ marginTop: "10px" }} > Get Details </button> </center> </OFMSUI.Col>

                    </OFMSUI.Row>
                    {tableEn && <>
                        <OFMSUI.Row className="mt-3 mb-3">
                            <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        position: "relative",
                                        width: "400px",
                                        height: "40px",
                                        background: isFocused
                                            ? "linear-gradient(90deg,rgb(224, 253, 117), #7873f5)"
                                            : "linear-gradient(90deg, #f5f7fa, #b8c6db)",
                                        borderRadius: "20px",
                                        padding: "5px 10px",
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        transition: "background 0.4s ease",
                                    }}
                                >

                                    <AiOutlineSearch
                                        icon={FaSearch}
                                        style={{
                                            position: "absolute",
                                            left: isFocused ? "90%" : "5%",
                                            transition: "left 1s ease, color 0.4s ease",
                                            fontSize: "20px",
                                            color: isFocused ? "#fff" : "#888",
                                        }}
                                    />
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                        style={{
                                            width: "100%", height: "100%", border: "none", outline: "none", paddingLeft: "35px", borderRadius: "20px", background: "transparent", color: "#444",
                                            fontSize: "16px",
                                            fontFamily: "Arial, sans-serif",
                                        }}
                                    />
                                </div>
                            </OFMSUI.Col>

                            <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                                <button type="button" className="btn btn-danger btn-sm" 
                                onClick={() => generatePDF("my-table", "OTS Re-consolation Report", "OTSReconsolationReport.pdf", 10)}

                                    style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                                <div style={{ float: "right", marginLeft: "3px" }}> <ReactHTMLTableToExcel id="test-table-xls-button"
                                    className="btn btn-success btn-sm" table="my-table"
                                    filename="Financeadditionalexpenditurereport" sheet="tablexls" buttonText="Excel" style={{
                                        backgroundColor: '#603913',
                                        borderColor: '#603913', color: '#ffffff',
                                        padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center',
                                        justifyContent: 'center'
                                    }} /> </div>
                            </OFMSUI.Col>
                        </OFMSUI.Row>
                        <div style={{ overflow: "auto", height: "500px" }}>

                            <Table striped bordered hover id="my-table" style={{ width: "100%" }}>
                                <thead className="fw-bold" style={{ top: "0px", position: "sticky" }}>
                                    <tr className="table_countshead">
                                        <th colSpan="13" style={{ textAlign: "left", padding: "10px" }}>
                                            <span style={{ marginRight: "0.5rem" }}> Report Type: </span>
                                            <b style={{ color: "#ff5722", marginRight: "0.8rem" }}> {formik.values.report_type} </b>

                                            {formik.values.report_type === "District" && (
                                                <>
                                                    <span style={{ marginRight: "0.5rem" }}> District: </span>
                                                    <b style={{ color: "#ff5722", marginRight: "0.8rem" }}> {districtName} </b>
                                                </>
                                            )}

                                            {formik.values.report_type === "scheme" && (
                                                <>
                                                    <span style={{ marginRight: "0.5rem" }}> Scheme: </span>
                                                    <b style={{ color: "#ff5722", marginRight: "0.8rem" }}> {formik.values.scheme ? "All" : formik.values.scheme} </b>
                                                </>
                                            )}

                                            <span style={{ marginRight: "0.5rem" }}> From Date: </span>
                                            <b style={{ color: "#ff5722", marginRight: "0.8rem" }}> {formik.values.FromDate} </b>

                                            <span style={{ marginRight: "0.5rem" }}> To Date: </span>
                                            <b style={{ color: "#ff5722", marginRight: "0.8rem" }}> {formik.values.ToDate} </b>
                                        </th>
                                    </tr>
                                    <tr className="table_countshead">
                                        <th rowSpan={2}>S.No.</th>
                                        {formik.values.report_type === "scheme" && <th rowSpan={2} >Scheme</th>}
                                        {tableDistEn && <th rowSpan={2}>District</th>}
                                        {tableDivEn && <><th rowSpan={2}>District</th><th rowSpan={2}>Division</th></>}
                                        {tableConstEn && <><th rowSpan={2}>District</th><th rowSpan={2}>Division</th><th rowSpan={2}>Constituency</th></>}
                                        {tableMandalEn && <><th rowSpan={2}>District</th><th rowSpan={2}>Division</th><th rowSpan={2}>Constituency</th><th rowSpan={2}>Mandal</th></>}
                                        <th colSpan={4} style={{ textAlign: "center" }}>Total Demand Receivable from Beneficiaries</th>
                                        <th colSpan={3} style={{ textAlign: "center" }}>Amount Remitted by Beneficiary (in Rs.)</th>
                                        <th colSpan={3} style={{ textAlign: "center" }}>Amount waived off by Governament	</th>


                                    </tr>

                                    <tr className="table_countshead">


                                        <th style={{ textAlign: "center" }}>No.of.Bens</th>
                                        <th style={{ textAlign: "center" }}>Princiapal Amount(in Rs.)</th>
                                        <th style={{ textAlign: "center" }}>Interest Amount(in Rs.)</th>
                                        <th style={{ textAlign: "center" }}>Total Amount (in Rs.)</th>
                                        <th style={{ textAlign: "center" }}>Princiapal Amount(in Rs.)</th>
                                        <th style={{ textAlign: "center" }}>Interest Amount(in Rs.)	</th>
                                        <th style={{ textAlign: "center" }}>Total Amount (in Rs.)</th>
                                        <th style={{ textAlign: "center" }}>Princiapal Amount(in Rs.)</th>
                                        <th style={{ textAlign: "center" }}>Interest Amount(in Rs.)	</th>
                                        <th style={{ textAlign: "center" }}>Total Amount (in Rs.)</th>
                                    </tr>
                                </thead>



                                <tbody>
                                    {filteredData?.length === 0 || filteredData === undefined ? (
                                        <tr >
                                            <td colSpan={24} style={{ fontSize: "15px", textAlign: "center" }}>
                                                No details found
                                            </td>
                                        </tr>
                                    ) : (
                                        filteredData.map((detail, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                {tableDistEn && <td> <Link style={{ cursor: "pointer", textDecoration: "none" }} onClick={() => { DrilldownColumns("Division", detail.dist_code); settableDistEn(false); setTableDivEn(true) }}>
                                                    {detail.dist_name} </Link></td>}

                                                {tableDivEn && <><td>{detail.dist_name}</td><td><Link style={{
                                                    cursor: "pointer", textDecoration:
                                                        "none"
                                                }} onClick={() => { DrilldownColumns("Constituency", detail.dist_code, detail.div_code); settableDistEn(false); setTableDivEn(false); setTableConstEn(true) }}> {detail.div_name} </Link></td></>}

                                                {tableConstEn && <><td>{detail.dist_name}</td><td> {detail.div_name} </td><td><Link style={{ cursor: "pointer", textDecoration: "none" }}
                                                    onClick={() => { DrilldownColumns("Mandal", detail.dist_code, detail.div_code, detail.cont_code, detail.mandal_code); settableDistEn(false); setTableDivEn(false); setTableConstEn(false); settableMandalEn(true) }}> {detail.cont_name} </Link></td></>}

                                                {tableMandalEn && <><td>{detail.dist_name}</td> <td>{detail.div_name} </td>
                                                    <td> {detail.cont_name} </td> <td>{detail.mandal_name}</td></>}


                                                {formik.values.report_type === "scheme" &&
                                                    <td>{detail.hsg_scheme_name}</td>}
                                                <td style={{ textAlign: "right" }}>
                                                    <Link style={{ cursor: "pointer", textDecoration: "none" }} onClick={() => { getOtsBenDetails(detail); }}> {detail.no_of_bens}</Link></td>

                                                <td style={{ textAlign: "right" }}>{detail.principal_tobepaid}</td>
                                                <td style={{ textAlign: "right" }}>{detail.interest_tobepaid}</td>
                                                <td style={{ textAlign: "right" }}>{parseFloat(detail.principal_tobepaid.toFixed(2)) + parseFloat(detail.interest_tobepaid.toFixed(2))}</td>
                                                <td style={{ textAlign: "right" }}>{detail.principal_paid.toFixed(2)}</td>
                                                <td style={{ textAlign: "right" }}>{detail.interest_paid.toFixed(2)}</td>
                                                <td style={{ textAlign: "right" }}>{detail.amountpayable.toFixed(2)}</td>
                                                <td style={{ textAlign: "right" }}>{detail.principal_waivedoff.toFixed(2)}</td>
                                                <td style={{ textAlign: "right" }}>{detail.interest_waivedoff.toFixed(2)}</td>
                                                <td style={{ textAlign: "right" }}>{parseFloat(detail.principal_waivedoff.toFixed(2)) + parseFloat(detail.interest_waivedoff.toFixed(2))}</td>

                                            </tr>
                                        ))
                                    )}
                                </tbody>

                                {filteredData?.length > 0 && (
                                    <tfoot style={{ position: "sticky", bottom: "0px" }}>
                                        <tr className="table_countshead">
                                            <td colSpan={tableDivEn ? 3 : tableConstEn ? 4 : tableMandalEn ? 5 : 2} style={{ textAlign: "center" }}>Total</td>
                                            <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (v.no_of_bens), 0)}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseFloat(v.principal_tobepaid)), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseFloat(v.interest_tobepaid)), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseFloat(v.interest_tobepaid)) + (parseFloat(v.principal_tobepaid)), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseFloat(v.principal_paid)), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseFloat(v.interest_paid)), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseFloat(v.amountpayable)), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseFloat(v.principal_waivedoff)), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseFloat(v.interest_waivedoff)), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseFloat(v.principal_waivedoff)) + (parseFloat(v.interest_waivedoff)), 0).toFixed(2)}</td>
                                        </tr>
                                    </tfoot>
                                )}
                            </Table>
                        </div>
                    </>}
                    {enable && <>
                        <OFMSUI.Row className="mt-3 mb-3">
                            <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        position: "relative",
                                        width: "400px",
                                        height: "40px",
                                        background: isFocused
                                            ? "linear-gradient(90deg,rgb(224, 253, 117), #7873f5)"
                                            : "linear-gradient(90deg, #f5f7fa, #b8c6db)",
                                        borderRadius: "20px",
                                        padding: "5px 10px",
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        transition: "background 0.4s ease",
                                    }}
                                >

                                    <AiOutlineSearch
                                        icon={FaSearch}
                                        style={{
                                            position: "absolute",
                                            left: isFocused ? "90%" : "5%",
                                            transition: "left 1s ease, color 0.4s ease",
                                            fontSize: "20px",
                                            color: isFocused ? "#fff" : "#888",
                                        }}
                                    />
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                        style={{
                                            width: "100%", height: "100%", border: "none", outline: "none", paddingLeft: "35px", borderRadius: "20px", background: "transparent", color: "#444",
                                            fontSize: "16px",
                                            fontFamily: "Arial, sans-serif",
                                        }}
                                    />
                                </div>
                            </OFMSUI.Col>

                            <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                                <button type="button" className="btn btn-danger btn-sm"
                                    onClick={() => generatePDF("my-table2", "OTS Re-consolation Report", "OTSReconsolationReport.pdf", 20)}


                                    style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                                <div style={{ float: "right", marginLeft: "3px" }}> <ReactHTMLTableToExcel id="test-table-xls-button"
                                    className="btn btn-success btn-sm" table="my-table2"
                                    filename="OTSReport" sheet="tablexls" buttonText="Excel" /> </div>
                            </OFMSUI.Col>
                        </OFMSUI.Row>
                        <div style={{ overflow: "auto", height: "500px" }}>
                            <TableWrapper> <OFMSUI.Table striped bordered hover id="my-table2">
                                <thead className="fw-bold" style={{ position: "sticky", top: "0px", backgroundColor: "#603913", color: "#fff" }}>
                                    <tr>
                                        <th>S.No</th>
                                        <th>District</th>
                                        <th>Constituency</th>
                                        <th>Mandal</th>
                                        <th>Village</th>
                                        <th>Scheme</th>
                                        <th>Ben Id</th>
                                        <th>Ben name</th>
                                        <th>father name</th>
                                        <th>aadhar number</th>
                                        <th>Mobile Number</th>
                                        <th>Patta Type</th>
                                        <th>Prinipal Amount</th>
                                        <th>Interest Amount</th>
                                        <th>Total To be paid</th>
                                        <th>Prinicipal paid</th>
                                        <th>Interest paid</th>
                                        <th>Total Amount ppaid</th>
                                        <th>Prinipal waived off</th>
                                        <th>Interest waived off</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data12?.length === 0 || data12?.length === undefined ? (
                                        <tr>
                                            <td
                                                colSpan="12"
                                                style={{ fontSize: "15px", textAlign: "center" }}
                                            >

                                                No details found
                                            </td>
                                        </tr>
                                    ) : (
                                        data12?.map((detail, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{detail.dist_name}</td>
                                                <td>{detail.cont_name}</td>
                                                <td>{detail.mandal_name}</td>
                                                <td>{detail.villagename}</td>
                                                <td>{detail.hsg_scheme_name}</td>
                                                <td>{detail.beneficiary_id}</td>
                                                <td>{detail.beneficiary_name}</td>
                                                <td>{detail.father_spouse_name}</td>
                                                <td>{detail.uid}</td>
                                                <td>{detail.mobileno}</td>
                                                <td>{detail.pattatype}</td>
                                                <td style={{ textAlign: "right" }}>{detail.principal_tobepaid}</td>
                                                <td style={{ textAlign: "right" }}>{detail.interest_tobepaid}</td>
                                                <td style={{ textAlign: "right" }}>{detail.total_tobepaid}</td>
                                                <td style={{ textAlign: "right" }}>{detail.prinicipal_paid}</td>
                                                <td style={{ textAlign: "right" }}>{detail.interest_paid}</td>
                                                <td style={{ textAlign: "right" }}>{detail.amountpayable}</td>
                                                <td style={{ textAlign: "right" }}>{detail.principal_waivedoff}</td>
                                                <td style={{ textAlign: "right" }}>{detail.interest_waivedoff}</td>

                                            </tr>
                                        ))
                                    )}
                                </tbody>

                                {data12?.length === 0 || data12?.length === undefined ? (
                                    <></>
                                ) : (
                                    <tfoot className="table_countshead">
                                        <tr>
                                            <td colSpan={12} className="text-center">
                                                Total
                                            </td>
                                            <td style={{ textAlign: "right" }}>{data12?.reduce((a, v) => a + parseFloat(v.principal_tobepaid), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{data12?.reduce((a, v) => a + parseFloat(v.interest_tobepaid), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{data12?.reduce((a, v) => a + parseFloat(v.total_tobepaid), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{data12?.reduce((a, v) => a + parseFloat(v.prinicipal_paid), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{data12?.reduce((a, v) => a + parseFloat(v.interest_paid), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{data12?.reduce((a, v) => a + parseFloat(v.amountpayable), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{data12?.reduce((a, v) => a + parseFloat(v.principal_waivedoff), 0).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{data12?.reduce((a, v) => a + parseFloat(v.interest_waivedoff), 0).toFixed(2)}</td>

                                        </tr>
                                    </tfoot>
                                )}
                            </OFMSUI.Table></TableWrapper>
                        </div>  </>}    </Form>
                </FormikProvider> </OFMSUI.Container> </>)
}
export default OTSReconsolationReport